import {Component, OnInit, SimpleChanges} from '@angular/core';
import {Geschaeftsvorgang} from './service/Model/Lieferung';
import {ActivatedRoute} from "@angular/router";

@Component({
  selector: 'app-geschaeftsvorgangs-table',
  templateUrl: './app.geschaeftsvorgangs.component.html',
  styleUrls: ['./app.geschaeftsvorgangs.component.scss']
})
export class GeschaeftsvorgangTableComponent implements OnInit {

  constructor(private route : ActivatedRoute){}

  ngOnInit() :void {
    console.log("Loading up the ges");
    this.route.params
      .subscribe(params => {
        console.log("Log Params" + JSON.parse(JSON.stringify(params)));
        console.log("Log params.geschaeftsvorgang" + JSON.parse(JSON.stringify(params.geschaeftsvorgang)));

        this.geschaeftsVorgang = [new Geschaeftsvorgang("231","ext","all","34","open")]
        // this.geschaeftsVorgang = params.geschaeftsvorgang;
        // console.log(this.geschaeftsVorgang);
      });
  }

  public geschaeftsVorgang: Geschaeftsvorgang[];

  public gesSlice : Geschaeftsvorgang[];
  public currentProcessSite: number = 0;
  public displayedProcesses: number;

  labelGeschaeftsvorgangTabelleHeader: any[] = [
    {id: 1, label: 'Anliegen Id'},
    {id: 2, label: 'Ordnungsmerkmal'},
    {id: 3, label: 'Vertrags Allianz'},
    {id: 4, label: 'Status'},
    {id: 5, label: 'Gevo Art Wert'},
  ];

  ngOnChanges(changes: SimpleChanges): void {
    if (this.geschaeftsVorgang != null) {
      this.loadFirstTenElements();
    }
  }

  setCurrentProcessSite(site: number) {
    this.currentProcessSite = site;
    this.changeDisplayedProcesses();
  }

  setNumberOfDisplayedPackages(numberDisplayed: number) {
    this.displayedProcesses = numberDisplayed;
    this.changeDisplayedProcesses();
  }

  private loadFirstTenElements() {
    this.currentProcessSite = 0;
    this.displayedProcesses = 10;
    this.changeDisplayedProcesses();
  }

  private changeDisplayedProcesses() {
    let displayedElements = this.displayedProcesses != 0 ? this.displayedProcesses : 10;
    this.gesSlice = this.geschaeftsVorgang.slice(this.currentProcessSite * displayedElements, (this.currentProcessSite + 1) * displayedElements);
  }

  maxLengthOfProcesses(): number {
    return this.geschaeftsVorgang.length;
  }
}
